import { addMinutes } from 'date-fns';

export const insertColonInTimeZone = (date: string | Date | number) => {
  if (date) {
    date = date.toString();
    if (date.indexOf('+') > -1) {
      date = date.replace(/(\+\d\d)(\d\d)$/g, '$1:$2');
    }
  }

  return date;
};

function getLastMonth(month: string, year: string) {
  if (Number(month) == 1) {
    return `${Number(year) - 1}-12`;
  }

  const lastMonth = Number(month) - 1;
  return lastMonth < 10 ? `${year}-0${lastMonth}` : `${year}-${lastMonth}`;
}

/**
 *
 * @param month Date string following the format 'yyyy-mm'
 * @returns month[] Array with the last 12 consecutive months with the format 'yyyy-mm'
 */
export function getLastUpTo12Months(month: string, oldestMonth?: string) {
  if (oldestMonth && month < oldestMonth) return [];

  const lastMonths: string[] = [];
  let currMonthString = month;
  lastMonths.push(currMonthString);

  for (let it = 0; it < 11; it++) {
    if (currMonthString == oldestMonth) break;
    const [currYear, currMonth] = currMonthString.split('-');

    const lastMonth = getLastMonth(currMonth, currYear);
    currMonthString = lastMonth;
    lastMonths.push(lastMonth);
  }

  return lastMonths;
}

export const getGMTDate = (date: Date) => {
  const offset = date.getTimezoneOffset() * -1;
  return addMinutes(date, offset);
};

export const getTimezoneName = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
